import angular from 'angular';

export default angular.module('hj.nearBottom', [])

  .provider('nearBottom', function () {
    var self = this;

    self.percent = 0.1;

    self.$get = function () {
      return {
        percent: self.percent,
      };
    };
  })

  .service('nearBottomService', ['$rootScope', '$window', '$document', '$timeout', 'nearBottom',
    function ($rootScope, $window, $document, $timeout, nearBottom) {
      var throttle = function (func) {
        var timeout;
        return function () {
          var context = this;
          var args = arguments;

          if ($window.requestAnimationFrame) {
            $window.cancelAnimationFrame(timeout);
            timeout = $window.requestAnimationFrame(function () {
              func.apply(context, args);
              timeout = null;
            });
          } else {
            $timeout.cancel(timeout);
            timeout = $timeout(function () {
              func.apply(context, args);
              timeout = null;
            }, 16);
          }
        };
      };

      var getDocHeight = function () {
        return Math.max(
          $document[0].body.scrollHeight, $document[0].documentElement.scrollHeight,
          $document[0].body.offsetHeight, $document[0].documentElement.offsetHeight,
          $document[0].body.clientHeight, $document[0].documentElement.clientHeight
        );
      };

      var documentHeight = getDocHeight();

      var check = function (force) {
        if (force) {
          documentHeight = getDocHeight();
        }

        var prevStatus = $rootScope.$nearBottom;
        var scrollPercent = ($window.scrollY || $window.pageYOffset) / (documentHeight - $window.innerHeight);
        var isNearBottom = scrollPercent > 1 - nearBottom.percent;

        if (!$rootScope.$nearBottom && isNearBottom) {
          $rootScope.$broadcast('nearBottom');
          $rootScope.$nearBottom = true;
        } else if ($rootScope.$nearBottom && !isNearBottom) {
          $rootScope.$nearBottom = false;
        }

        if ($rootScope.$nearBottom !== prevStatus && !$rootScope.$$phase) {
          $rootScope.$apply();
        }
      };

      var throttledCheck = throttle(check);

      var resize = function () {
        documentHeight = getDocHeight();
      };

      var throttledResize = throttle(resize);

      return {
        percent: nearBottom.percent,
        check: check,
        enable: function () {
          angular.element($window).on('scroll', throttledCheck);
          angular.element($window).on('resize', throttledResize);
        },
        disable: function () {
          angular.element($window).off('scroll', throttledCheck);
          angular.element($window).off('resize', throttledResize);
        },
      };
    },
  ])

  .run(['nearBottomService', function (nearBottomService) {
    nearBottomService.enable();
  }]);
